<template>
  <v-row
    v-if="current_dialog !== null"
    justify="center"
  >
    <v-dialog
      v-model="current_dialog.show"
      persistent
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ current_dialog.title }}
        </v-card-title>
        <v-card-text>
          {{ current_dialog.text }}
          <v-text-field
            v-if="'reason' in current_dialog"
            v-model="reason_value"
            class="mt-5"
            dense
            autofocus
            :label="current_dialog.reason"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="'btn_1_title' in current_dialog"
            :color="('btn_1_color' in current_dialog) ? current_dialog.btn_2_color : ''"
            text
            @click="click_btn_1"
          >
            {{ current_dialog.btn_1_title }}
          </v-btn>
          <v-btn
            v-if="'btn_2_title' in current_dialog"
            :color="('btn_2_color' in current_dialog) ? current_dialog.btn_2_color : ''"
            text
            @click="click_btn_2"
          >
            {{ current_dialog.btn_2_title }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "gnrl_dialog",
  data () {
    return {
      reason_value: "",
    }
  },
  methods: {
    click_btn_1(){
      this.current_dialog.show = false
      if ('btn_1_update' in this.current_dialog) {
        if ('reason' in this.current_dialog) {
          this.current_dialog.btn_1_update.context += "?reason=" + this.reason_value
        }
        this.$store.dispatch("update", this.current_dialog.btn_1_update)
      }
      this.$store.state.general.dialogs.shift()
    },
    click_btn_2(){
      this.current_dialog.show = false
      if ('btn_2_update' in this.current_dialog) {
        if ('reason' in this.current_dialog) {
          this.current_dialog.btn_2_update.context += "?reason=" + this.reason_value
        }
        this.$store.dispatch("update", this.current_dialog.btn_2_update)
      }
      this.$store.state.general.dialogs.shift()
    }
  },
  computed: {
    current_dialog(){
      if(this.$store.state.general.dialogs.length == 0){
        return null
      }
      else {
        return this.$store.state.general.dialogs[0]
      }
    }
  }
};
</script>

<style scoped>

</style>
